// Mock data for Caliber Auto Repair — will be replaced with backend data later

export const BUSINESS = {
  name: "Caliber Auto Repair",
  brand: "CaliberAUTO",
  tagline: "LEVEL ABOVE THE CLASS",
  subtitle: "Veteran-owned, exceptional pricing",
  description:
    "Professional autobody shop that treats you as the customer, not your insurance company. Let us show you why choosing an independent shop like us should be your first priority — YOU and your vehicle are what's most important to us.",
  phone: "(330) 737-7109",
  phoneHref: "tel:+13307377109",
  email: "info@caliberautorepair.com",
  address: "500 Golden Oak Pkwy, Bedford, OH 44146",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=500+Golden+Oak+Pkwy+Bedford+OH+44146",
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 2:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxhdXRvJTIwYm9keSUyMHNob3B8ZW58MHx8fHwxNzg0NjgxNzE4fDA&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1727893304219-063d142ce6f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxhdXRvJTIwYm9keSUyMHNob3B8ZW58MHx8fHwxNzg0NjgxNzE4fDA&ixlib=rb-4.1.0&q=85";

export const FEATURES = [
  "Best Prices",
  "Free Estimates",
  "Collision Repair",
  "Expert Paint",
  "Paintless Dent Repair",
  "Frame Repair",
  "Car Drop Facility",
  "In-House Towing",
];

export const SERVICES = [
  {
    id: "collision-repair",
    icon: "CarFront",
    title: "Collision Repair",
    description:
      "Complete accident damage restoration. From minor fender benders to major collisions, we bring your vehicle back to factory condition.",
  },
  {
    id: "auto-painting",
    icon: "Paintbrush",
    title: "Auto Painting",
    description:
      "Professional refinishing with precise color matching and blending, so your repair is invisible and your paint looks showroom-new.",
  },
  {
    id: "paintless-dent-repair",
    icon: "Sparkles",
    title: "Paintless Dent Repair",
    description:
      "Remove dents and dings without repainting — faster turnaround, lower cost, and your original factory finish stays intact.",
  },
  {
    id: "frame-repair",
    icon: "Frame",
    title: "Frame Repair",
    description:
      "Precision frame straightening and structural repair to restore your vehicle's safety, alignment, and integrity after an accident.",
  },
  {
    id: "towing",
    icon: "Truck",
    title: "In-House Towing",
    description:
      "Stuck after an accident? We come to you. Our in-house towing gets your vehicle to our shop quickly and safely — no third parties.",
  },
  {
    id: "car-drop",
    icon: "KeyRound",
    title: "Car Drop Facility",
    description:
      "Drop your car off on your schedule with our convenient car drop facility. We'll take it from there and keep you updated.",
  },
  {
    id: "insurance",
    icon: "FileCheck",
    title: "Insurance Assistance",
    description:
      "We work directly with insurance adjusters and rental companies on your behalf — but we always answer to YOU, not the insurer.",
  },
  {
    id: "estimates",
    icon: "ClipboardList",
    title: "Free Estimates",
    description:
      "On-the-spot, honest estimates with multiple options. Affordable solutions without compromising performance or aesthetics.",
  },
  {
    id: "detailing",
    icon: "Car",
    title: "Detail & Finish",
    description:
      "Every repair ends with a meticulous finish — your car leaves our shop looking like it just rolled out of the factory.",
  },
];

export const WHY_CHOOSE = [
  {
    icon: "Shield",
    title: "Veteran-Owned & Operated",
    description:
      "Discipline, integrity, and attention to detail — the values we served with are the values we work with every day.",
  },
  {
    icon: "HandHeart",
    title: "You're Our Customer",
    description:
      "We treat you as the customer, not your insurance company. Your interests come first — always.",
  },
  {
    icon: "BadgeDollarSign",
    title: "Exceptional Pricing",
    description:
      "Fair, transparent prices with free estimates and multiple repair options to fit your budget.",
  },
  {
    icon: "Clock",
    title: "Fast Turnaround",
    description:
      "Most repairs completed in days, not weeks. We tell you a date — and we hit it.",
  },
];

export const PROCESS_STEPS = [
  { step: "01", title: "Get In Touch", description: "Call, email, or book online. Need a tow? Our in-house towing comes to you." },
  { step: "02", title: "Free Estimate", description: "Honest, on-the-spot assessment with multiple repair options and fair pricing." },
  { step: "03", title: "Expert Repair", description: "We handle the insurance, the rental, and the repair — with factory-quality work." },
  { step: "04", title: "Drive Away Happy", description: "A full walkthrough of the work done, and a car that looks brand new again." },
];

export const GALLERY = [
  { id: 1, src: "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxhdXRvJTIwYm9keSUyMHNob3B8ZW58MHx8fHwxNzg0NjgxNzE4fDA&ixlib=rb-4.1.0&q=85", caption: "Precision work in our shop", category: "Shop" },
  { id: 2, src: "https://images.unsplash.com/photo-1727893304219-063d142ce6f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxhdXRvJTIwYm9keSUyMHNob3B8ZW58MHx8fHwxNzg0NjgxNzE4fDA&ixlib=rb-4.1.0&q=85", caption: "State-of-the-art facility", category: "Shop" },
  { id: 3, src: "https://images.pexels.com/photos/33814680/pexels-photo-33814680.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Professional paint booth", category: "Paint" },
  { id: 4, src: "https://images.unsplash.com/photo-1711386689622-1cda23e10217?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxjb2xsaXNpb24lMjByZXBhaXJ8ZW58MHx8fHwxNzg0NjgxNzI0fDA&ixlib=rb-4.1.0&q=85", caption: "Collision damage assessment", category: "Collision" },
  { id: 5, src: "https://images.unsplash.com/photo-1673187139211-1e7ec3dd60ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxjb2xsaXNpb24lMjByZXBhaXJ8ZW58MHx8fHwxNzg0NjgxNzI0fDA&ixlib=rb-4.1.0&q=85", caption: "Body panel restoration", category: "Collision" },
  { id: 6, src: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxjYXIlMjBtZWNoYW5pY3xlbnwwfHx8fDE3ODQ2ODE3MTl8MA&ixlib=rb-4.1.0&q=85", caption: "Under-the-hood expertise", category: "Repair" },
  { id: 7, src: "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxjYXIlMjBtZWNoYW5pY3xlbnwwfHx8fDE3ODQ2ODE3MTl8MA&ixlib=rb-4.1.0&q=85", caption: "Careful diagnostics", category: "Repair" },
  { id: 8, src: "https://images.pexels.com/photos/8478259/pexels-photo-8478259.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Detail-driven technicians", category: "Repair" },
  { id: 9, src: "https://images.pexels.com/photos/35149611/pexels-photo-35149611.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Every panel, perfected", category: "Shop" },
  { id: 10, src: "https://images.pexels.com/photos/4480507/pexels-photo-4480507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Quality control inspection", category: "Shop" },
  { id: 11, src: "https://images.pexels.com/photos/17623850/pexels-photo-17623850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Showroom-ready finish", category: "Finish" },
  { id: 12, src: "https://images.pexels.com/photos/29504462/pexels-photo-29504462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Final polish & delivery", category: "Finish" },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "SlovakVladik SV",
    role: "Customer",
    rating: 5,
    text: "The work of this shop and its staff can be described in two words — professionalism and care. Ray, the owner, is always ready to personally help you at every stage: from towing and damage assessment to the moment you pick up your car looking like it just rolled out of the factory. Fair prices, speed, and high-quality work. Highly recommended!",
  },
  {
    id: 2,
    name: "Traneca Hicks",
    role: "Customer",
    rating: 5,
    text: "I am thoroughly pleased with Caliber Auto Body and Collision Repair. Ray assured me I'd have my car back in 3 days, and the morning of the third day he called to say it was ready. The staff is friendly and courteous, the establishment is clean, and above all their prices are reasonable! I recommend this shop to everyone.",
  },
  {
    id: 3,
    name: "Rose Gruss",
    role: "Customer",
    rating: 5,
    text: "Top rated in my opinion. Ray and Christina were both very helpful in getting my car fixed. Ray worked with the insurance adjuster and the rental company so I had transportation while the work was completed. He took the time to explain everything. The car looks like new. I highly recommend this body shop for any work needed.",
  },
  {
    id: 4,
    name: "Deanna Lee",
    role: "Customer",
    rating: 5,
    text: "They definitely should have a 10-stars button. Not only did they fix my car, they came and towed it to their shop. A1 service all around. If I had to use them again I definitely would.",
  },
  {
    id: 5,
    name: "Chris Palange",
    role: "Customer",
    rating: 5,
    text: "Easy to see why this place has 5 stars across the board. Ray is terrific — prompt in communication, thorough, and provided an estimate on the spot with multiple options. He found affordable solutions without compromising performance or aesthetics. Repairs done within 3 days. The best experience I have ever had regarding a car repair.",
  },
  {
    id: 6,
    name: "Aredbonef",
    role: "Customer",
    rating: 5,
    text: "When I tell you Ray, Christina and crew are awesome — they're awesome! I was involved in an accident and they got my car all the way together, from actively conversing to arranging the rental pickup. Ray, thank you so much! I highly recommend them!",
  },
  {
    id: 7,
    name: "Val Avakyan",
    role: "Customer",
    rating: 5,
    text: "Nice people, reliable business. Recommended.",
  },
  {
    id: 8,
    name: "Simon Hersch",
    role: "Customer",
    rating: 5,
    text: "I had a great experience. They were extremely easy to work with, got my car fixed very quickly, and the price was incredibly affordable. The whole process was smooth and stress-free. I really appreciate the honesty and efficiency — highly recommend!",
  },
];

export const SERVICE_OPTIONS = [
  "Collision Repair",
  "Auto Painting",
  "Paintless Dent Repair",
  "Frame Repair",
  "Towing Request",
  "Free Estimate",
  "Insurance Claim Assistance",
  "Other",
];

// Static site content above stays local — appointments & contact messages are now saved via backend API.
